/* ============== Header help center ============== */
// document.querySelector('.help-title').addEventListener('click', function () {
//   document.querySelector('.help-dropdown').classList.toggle('active');
// });

const helpTitle = document.querySelector('.help-title');
const helpDropdown = document.querySelector('.help-dropdown');

function isHoveringHelpElements(event) {
  const target = event.target;
  return helpTitle.contains(target) || helpDropdown.contains(target);
}

helpTitle.addEventListener('mouseenter', function () {
  helpDropdown.classList.add('active');
});

document.body.addEventListener('mouseover', function (event) {
  if (!isHoveringHelpElements(event)) {
    helpDropdown.classList.remove('active');
  }
});

/* ============== header menu close icon trigger ============== */
document.querySelector('.mobile-menu-close').addEventListener('click', function() {
    let menuIcon = document.querySelector('.head-slot-nav-mobile-link-wrapper');
    if (menuIcon) { 
        menuIcon.click();
    }
});

/* ============== recommdation product trigger click arrow ============== */
document.querySelector('.custom-flickity-arrows.custom-flicky .flickity-prev')?.addEventListener('click', function () {
  document.querySelector('.custom-flickity-arrows:not(.custom-flicky) .flickity-prev')?.click();
});

document.querySelector('.custom-flickity-arrows.custom-flicky .flickity-next')?.addEventListener('click', function () {
  document.querySelector('.custom-flickity-arrows:not(.custom-flicky) .flickity-next')?.click();
});

// checkout btn set 


document.addEventListener('DOMContentLoaded', function() {
  const checkoutLink = document.getElementById('dynamic-checkout-link');
  const qtyInput = document.querySelector('.quantity-input-field');

  if (checkoutLink && qtyInput) {
    function updateCheckoutLink() {
      const qty = parseInt(qtyInput.value) || 1;
      const variantId = checkoutLink.getAttribute('data-var');
      checkoutLink.href = `/cart/${variantId}:${qty}`;
    }

    // Update on page load and whenever qty changes
    updateCheckoutLink();
    qtyInput.addEventListener('input', updateCheckoutLink);
    qtyInput.addEventListener('change', updateCheckoutLink);
  }
});
